// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3lJAo","buttons":"SendReceipts_buttons__125VX","email":"SendReceipts_email__Q6MHT","bookApptTitle":"SendReceipts_bookApptTitle__1bsis"};